import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';

const NotificationTextFile = ({ file, url, linkText }) => {
  const intl = useIntl();

  const { location } = window;

  let hash = '';
  if (url && url.indexOf('#') >= 0) {
    hash = url.split('#')[1];
  }

  const fileTo = {
    pathname: url ? url.split('#')[0] : `/files/${file.uuid}`,
    hash,
    state: {
      modal: true,
      backUrl: `${location.pathname}${location.search ? `/${location.search}` : ''}`,
    },
  };

  const text = linkText ||
    (file.display_name || intl.formatMessage({ defaultMessage: '(deleted file)' }));

  return (
    <>
      {file.uuid ? (
        <Link to={fileTo}>
          <strong>{text || ''}</strong>
        </Link>
      ) : (
        <strong>{text || ''}</strong>
      )}
    </>
  );
};

NotificationTextFile.propTypes = {
  file: PropTypes.object,
  url: PropTypes.string,
  linkText: PropTypes.string,
};

NotificationTextFile.defaultProps = {
  file: {
    display_name: '',
  },
  url: null,
  linkText: null,
};

export default NotificationTextFile;
